// extracted by mini-css-extract-plugin
export var active = "_5y-7";
export var container = "_5y-0";
export var evenWidth = "_5y-4";
export var large = "_5y-5";
export var outlet = "_5y-8";
export var slide = "_5y-2";
export var small = "_5y-6";
export var tab = "_5y-3";
export var tabs = "_5y-1";